import React from 'react'
import { createTheme, rem } from '@mantine/core';
import { IconChevronDown } from '@tabler/icons-react';

export const theme = createTheme({
  colors: {
    marketpayBlue: [
      "#eaf5ff",
      "#d7e5f9",
      "#afc8ec",
      "#83aae0",
      "#5f90d5",
      "#4880d1",
      "#3a78cf",
      "#2c66b7", 
      "#225ba5",
      "#0e4e93"
    ],
    skyblue: [
      "#e0fbff",
      "#ccf1ff",
      "#9de0fc",
      "#6acff9",
      "#42c1f7",
      "#a2e1fc",  // skyblue-xlight
      "#71d2fa",  // skyblue-light
      "#0eb2f6",  // skyblue
      "#0a91ca",  // skyblue-dark
      "#05678f"   // skyblue-xdark
    ],
    green: [
      "#eafcea",
      "#dbf2db",
      "#b8e2b8",
      "#93d092",
      "#74c272",
      "#a7d8a7",  // green-xlight
      "#83c983",  // green-light
      "#5cb85c",  // green
      "#367d37",  // green-dark
      "#1f4720"   // green-xdark
    ],
    red: [
      "#ffecec",
      "#f9d8d9",
      "#ebafb2",
      "#df8588",
      "#d46063",
      "#f76e54",  // red-xlight
      "#f65655",  // red-light
      "#c33338",  // red
      "#96272c",  // red-dark
      "#7a1f24"   // red-xdark
    ],
    violet: [
      "#f8efff",
      "#e8dcf4",
      "#cdb9e3",
      "#b292d2",
      "#9a71c3",
      "#b494d3",  // violet-xlight
      "#9a70c4",  // violet-light
      "#7e4ab2",  // violet
      "#5a3580",  // violet-dark
      "#41265c"   // violet-xdark
    ],
    orange: [
      "#fff2e4",
      "#ffe2d0",
      "#fbc5a0",
      "#f7a56c",
      "#f58a41",
      "#f8a66e",  // orange-xlight
      "#f6893e",  // orange-light
      "#e0610a",  // orange
      "#ac4a09",  // orange-dark
      "#7b3506"   // orange-xdark
    ],
    ghost: [
      "#fcf1fc",
      "#e9e5ec",
      "#cccbd2",
      "#b0aeb7",
      "#97959f",
      "#f6f7f8",  // ghost-xlight
      "#e9e9ec",  // ghost-light
      "#d9d9dd",  // ghost
      "#c3c3ca",  // ghost-dark
      "#a3a1aa"   // ghost-xdark
    ],
    gravel: [
      "#f5f4f5",
      "#e6e6e6",
      "#cccccc",
      "#afafaf",
      "#979797",
      "#817c89",  // gravel-xlight
      "#625d6a",  // gravel-light
      "#464249",  // gravel
      "#302c2c",  // gravel-dark
      "#000000"   // gravel-xdark
    ]
  },
  primaryShade: 7,
  primaryColor: 'marketpayBlue',
  fontSizes: {
    xs: '10px',
    sm: '12px',
    md: '14px',
    lg: '16px',
    xl: '18px'
  },
  headings: {
    fontFamily: 'Roboto, sans-serif',
    fontWeight: '500',
    textWrap: 'wrap',
    sizes: {
      h1: {
        fontSize: '56px',
        lineHeight: '1.2',
        fontWeight: '900'
      },
      h2: {
        fontSize: '28px',
        lineHeight: '1.2',
        fontWeight: '700'
      },
      h3: {
        fontSize: '24px',
        lineHeight: '1.2',
        fontWeight: '700'
      },
      h4: {
        fontSize: '22px',
        lineHeight: '1.2',
        fontWeight: '400'
      },
      h5: {
        fontSize: '18px',
        lineHeight: '1.2',
        fontWeight: '400'
      },
      h6: {
        fontSize: '14px',
        lineHeight: '1.2',
        fontWeight: '700'
      }
    }
  }
})



export enum COLORS {
  BORDER = '#d5e0ea',
  HEADING = '#19132E',
  BODY_PRIMARY = '#485665',
  BODY_SECONDARY = '#617389',
  BLACK = '#19132E',
  RED = '#b91f1f',
  BLUE_GREY = '#eaf0f5'
}

export const globalJobMatchingTheme = createTheme({
  colors: {
    black: [COLORS.BLACK, COLORS.BLACK, COLORS.BLACK, COLORS.BLACK, COLORS.BLACK, COLORS.BLACK, COLORS.BLACK, COLORS.BLACK, COLORS.BLACK, COLORS.BLACK],
    darkGrey: [COLORS.BODY_PRIMARY, COLORS.BODY_PRIMARY, COLORS.BODY_PRIMARY, COLORS.BODY_PRIMARY, COLORS.BODY_PRIMARY, COLORS.BODY_PRIMARY, COLORS.BODY_PRIMARY, COLORS.BODY_PRIMARY, COLORS.BODY_PRIMARY, COLORS.BODY_PRIMARY],
    lightText: [COLORS.BODY_SECONDARY, COLORS.BODY_SECONDARY, COLORS.BODY_SECONDARY, COLORS.BODY_SECONDARY, COLORS.BODY_SECONDARY, COLORS.BODY_SECONDARY, COLORS.BODY_SECONDARY, COLORS.BODY_SECONDARY, COLORS.BODY_SECONDARY, COLORS.BODY_SECONDARY],
    darkText: [COLORS.BODY_PRIMARY, COLORS.BODY_PRIMARY, COLORS.BODY_PRIMARY, COLORS.BODY_PRIMARY, COLORS.BODY_PRIMARY, COLORS.BODY_PRIMARY, COLORS.BODY_PRIMARY, COLORS.BODY_PRIMARY, COLORS.BODY_PRIMARY, COLORS.BODY_PRIMARY],
    lightBlue: ["#6bbdd4","#6bbdd4","#6bbdd4","#6bbdd4","#6bbdd4","#6bbdd4","#6bbdd4","#6bbdd4","#6bbdd4","#6bbdd4"],
    blueGrey: [COLORS.BLUE_GREY, COLORS.BLUE_GREY, COLORS.BLUE_GREY, COLORS.BLUE_GREY, COLORS.BLUE_GREY, COLORS.BLUE_GREY, COLORS.BLUE_GREY, COLORS.BLUE_GREY, COLORS.BLUE_GREY, COLORS.BLUE_GREY],
    newBlue: ["#e6f4ff", "#d1e3ff", "#a2c4f8", "#71a4f3", "#4888ee", "#2d76eb", "#1d6eeb", "#1467e8", "#1467e8", "#0047a8"],
    darkOrange: ["#ffefe4", "#ffdecf", "#f9bda1", "#f4996f", "#ef7a45", "#ed672a", "#ed5c1b", "#ed6629", "#ed6629", "#a53601"],
    lightOrange: ["#fff6e1", "#ffeccd", "#fad89f", "#f6c36c", "#f3b142", "#f1a526", "#f09f15", "#f1a628", "#f1a628", "#a66900"],
    red: [COLORS.RED, COLORS.RED, COLORS.RED, COLORS.RED, COLORS.RED, COLORS.RED, COLORS.RED, COLORS.RED, COLORS.RED, COLORS.RED],
    purple: ["#f2eaff", "#ded1ff", "#b89ffd", "#916afa", "#703df7", "#5b20f6", "#5011f7", "#956ffa", "#956ffa", "#2e00ae"],
    green: ["#e8fcef", "#d9f3e2", "#b6e4c5", "#8fd4a6", "#6ec78c", "#59bf7b", "#4dbb72", "#44b369", "#44b369", "#227f45"],
    newGrey: ["#eaf0f5", "#eaf0f5", "#d5e0ea", "#d520ea", "#617389", "#617389", "#617389", "#485665", "#484665", "#485665"],
  },
  primaryColor: 'newBlue',
  fontFamily: 'Inter',
  fontSizes: {
    xs: '12px',
    sm: '13px',
    md: '14px',
    lg: '15px',
    xl: '16px'
  },
  primaryShade: 7,
  cursorType: 'pointer',
  defaultRadius: 4,
  focusRing: 'never',
  headings: {
    fontFamily: 'Inter',
    sizes: {
      h1: { fontSize: '20px', fontWeight: '500' },
      h2: { fontSize: '18px', fontWeight: '500' },
      h3: { fontSize: '16px', fontWeight: '500' },
      h4: { fontSize: '14px', fontWeight: '500' },
      h5: { fontSize: '12px', fontWeight: '500' },
      h6: { fontSize: '10px', fontWeight: '500' },
    },
  },
  shadows: {
    md: '0px 10px 20px 0px rgba(56, 96, 167, 0.07)',
    xl: '5px 5px 3px rgba(0, 0, 0, .25)',
  },
  components: {
    Button: {
      styles: () => ({
        root: {
          borderRadius: 4,
          fontFamily: 'Inter',
          fontSize: 13,
          fontStyle: 'normal',
          fontWeight: 600,
          height: 40,
          lineHeight: 18.2,
          textEdge: 'cap',
          width: 172,
        },
      })
    },
    Card: {
      styles: {
        root: {
          borderColor: COLORS.BORDER,
          borderRadius: 4
        }
      },
      defaultProps: {
        withBorder: true
      }
    },
    Text: {
      styles: {
        root: {
          fontFamily: 'Inter',
          fontWeight: 400,
          color: COLORS.BODY_SECONDARY
        }
      },
      defaultProps: {
        size: 'md',
      }
    },
    Title: {
      styles: {
        root: {
          color: COLORS.HEADING
        }
      }
    },
    Table: {
      styles: {
        thead: {
          color: '#667085',
          backgroundColor: '#fcfcfd',
          fontFamily: 'Inter',
          fontSize: 12,
          borderBottom: '1px solid #d5e0ea'
        },
        tbody: {
          fontFamily: 'Inter',
          fontSize: 14,
          fontWeight: 400,
        },
        tr: {
          height: 44
        }
      },
      defaultProps: {
        withTableBorder: true,
        borderColor: '#d5e0ea'
      }
    },
    Radio: {
      styles: {
        root: {
          fontFamily: 'Inter',
          fontWeight: 500
        }
      }
    },
    Checkbox: {
      styles: {
        root: {
          fontFamily: 'Inter',
          fontWeight: 500
        }
      }
    },
    Select: {
      styles: {
        root: {
          fontFamily: 'Inter',
          fontWeight: 500
        },
        input: {
          height: 49,
          borderRadius: 8
        },
        option: {
          textAlign: 'center',
          fontWeight: 500
        }
      },
      defaultProps: {
        rightSection: <IconChevronDown style={{ marginRight: 10 }} size={30} color='#485665' />
      },
    },
    PillsInput: {
      styles: {
        root: {
          fontFamily: 'Inter',
          fontWeight: 500
        },
        input: {
          height: '100%',
          borderRadius: 8
        }
      }
    },
    NumberInput: {
      styles: {
        root: {
          fontFamily: 'Inter',
          fontWeight: 500
        },
        input: {
          height: 45,
          borderRadius: 4,
          fontSize: 15,
        },
        label: {
          fontSize: 15,
          fontWeight: 400
        }
      },
      defaultProps: {
        hideControls: true
      }
    },
    TextInput: {
      styles: {
        root: {
          fontFamily: 'Inter',
          fontWeight: 500
        },
        input: {
          height: 49,
          borderRadius: 8
        }
      }
    }
  },
});
